<template lang="pug">
  nt-dialog(
    v-model='dialog'
    scrollable
    :title="$t('voucher')"
    color='var(--bg-main-color)'
  )  
    v-card-text
      n-card-voucher(
        v-for='(item,i) in items.data'
        :key='i'
        :item='item'
        @click='addVoucher(item)'
      )

</template>
<script>  
import { vouchers as apiVouchers } from '@/apis'   

export default {
  data: () => ({
    dialog: false,  
    items : {
      data : [],
      meta : {
        current_page : 1
      }
    },   
  }) ,  
  methods:{    
    async load (params = {}) {
      params = { 
        page : this.items.meta.current_page,   
        is_stake_extra_reward:true,
        scope : 'AVAILABLE',
      }
      const [err, data,,meta] =  await apiVouchers.get(params) 
      
      if(err){
        this.$alert('',err,'warning')
        return
      } 
       
      this.items.data = data
      this.items.meta = meta   
    },
    
    addVoucher (item) {
      this.$emit('addvoucher',item)
      this.close()
    },

    close () {
      this.dialog = false
    },
 
    async open () {  
      await this.load()
      
      if(this.items.data.length !== 0) {
        this.dialog = true 
      } 
    }, 
  }
}
</script>  